import { TabButtonLink, TabList } from 'components/DataSourceTab';
import { generatePath, useParams, useRouteMatch } from 'react-router-dom';
import Stack from 'components/Stack';
import { useCountryParam } from 'utils/hooks';

export const activeDataSource = {
    google: 'google',
    tiktok: 'tiktok',
    instagram: 'instagram',
};

function WatchlistTabs() {
    const match = useRouteMatch();
    const { watchlistId, dataSource } = useParams();
    const { mutateToWithCountryParam } = useCountryParam();

    return (
        <Stack $space="1.25rem">
            <div css="display: flex; justify-content: center;">
                <TabList>
                    <TabButtonLink
                        intent={!dataSource ? 'primary' : 'secondary'}
                        to={mutateToWithCountryParam(
                            generatePath(match.path, { watchlistId }),
                        )}
                    >
                        Overview
                    </TabButtonLink>
                    <TabButtonLink
                        intent={
                            dataSource === activeDataSource.google
                                ? 'primary'
                                : 'secondary'
                        }
                        to={mutateToWithCountryParam(
                            generatePath(
                                `${match.path}/${activeDataSource.google}`,
                                { watchlistId },
                            ),
                        )}
                    >
                        Google
                    </TabButtonLink>
                    <TabButtonLink
                        intent={
                            dataSource === activeDataSource.tiktok
                                ? 'primary'
                                : 'secondary'
                        }
                        to={mutateToWithCountryParam(
                            generatePath(
                                `${match.path}/${activeDataSource.tiktok}`,
                                { watchlistId },
                            ),
                        )}
                    >
                        TikTok
                    </TabButtonLink>
                    <TabButtonLink
                        intent={
                            dataSource === activeDataSource.instagram
                                ? 'primary'
                                : 'secondary'
                        }
                        to={mutateToWithCountryParam(
                            generatePath(
                                `${match.path}/${activeDataSource.instagram}`,
                                { watchlistId },
                            ),
                        )}
                    >
                        Instagram
                    </TabButtonLink>
                </TabList>
            </div>
        </Stack>
    );
}

export default WatchlistTabs;
